module.exports = __webpack_public_path__ + "static/media/estrellagalicia.80424468.webp";